import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';

import FeedEvent, {
  FeedLeftImage,
  FeedTitleAndDescription,
} from './feed-event';

const InfluencerAddedEvent = ({
  isCompact,
  messageData: {
    resource: {
      id,
      createdBy,
      createdDate,
    },
    influencer: {
      attributes: { name, thumbnail, primarySocialHandle },
    },
  },
}) => (
  <FeedEvent
    isCompact={isCompact}
    actionText="added a new influencer"
    createdBy={createdBy}
    createdDate={createdDate}
  >
    <Card
      fluid
      onClick={() => window.open(`/influencer/${id}/statistics`, '_blank')}
    >
      <Card.Content>
        <FeedLeftImage
          src={thumbnail}
        />
        <FeedTitleAndDescription
          title={name}
          description={primarySocialHandle}
        />
      </Card.Content>
    </Card>
  </FeedEvent>
);

InfluencerAddedEvent.propTypes = {
  messageData: PropTypes.object.isRequired,
  isCompact: PropTypes.bool.isRequired,
};

export default InfluencerAddedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/influencer-added-event.js
 **/